
import React from 'react';

interface ValueCard {
  icon: string;
  title: string;
  description: string;
  benefits: string[];
}

const valueCards: ValueCard[] = [
  {
    icon: 'ri-refresh-line',
    title: '减少返工与内耗',
    description: '通过前置校验与过程留痕，降低因资料缺失或口径不一致导致的返工成本',
    benefits: [
      '缺项前置发现，避免提交后退单',
      '退单原因可复盘，减少重复错误',
      '团队协作效率提升，减少内部沟通成本'
    ]
  },
  {
    icon: 'ri-file-text-line',
    title: '降低解释成本',
    description: '统一口径与差异留痕机制，让业务数据"说得清、追得到"',
    benefits: [
      '口径统一，数据穿透下保持一致性',
      '差异留痕，异常情况可追溯',
      '一票一链路，核销关系清晰可解释'
    ]
  },
  {
    icon: 'ri-shield-check-line',
    title: '提升审计准备度',
    description: '目录化归档与权限留痕，让企业随时具备抽查与审计应对能力',
    benefits: [
      '归档目录化，资料定位快速准确',
      '权限与导出留痕，操作可追溯',
      '证据链完整，审计准备时间大幅缩短'
    ]
  }
];

const GovernanceValue: React.FC = () => {
  return (
    <section className="py-20 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        {/* 标题区域 */}
        <div className="text-center mb-16">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">
            治理带来的经营价值
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            从"能操作"升级为"可解释、可追溯、可复盘"，治理能力的提升直接转化为企业的经营优势
          </p>
        </div>

        {/* 价值卡片网格 */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {valueCards.map((card, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-8 shadow-sm hover:shadow-lg transition-all duration-300 border border-gray-100 group"
            >
              {/* 图标 */}
              <div className="w-14 h-14 flex items-center justify-center bg-gradient-to-br from-teal-500 to-teal-600 rounded-xl mb-6 group-hover:scale-110 transition-transform duration-300">
                <i className={`${card.icon} text-2xl text-white`}></i>
              </div>

              {/* 标题 */}
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                {card.title}
              </h3>

              {/* 描述 */}
              <p className="text-gray-600 mb-6 leading-relaxed">
                {card.description}
              </p>

              {/* 典型表现列表 */}
              <div className="space-y-3">
                <div className="text-sm font-semibold text-gray-700 mb-3">
                  典型表现：
                </div>
                {card.benefits.map((benefit, idx) => (
                  <div key={idx} className="flex items-start gap-3">
                    <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i className="ri-checkbox-circle-fill text-teal-500 text-lg"></i>
                    </div>
                    <span className="text-sm text-gray-700 leading-relaxed">
                      {benefit}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* 底部说明 */}
        <div className="mt-12 text-center">
          <p className="text-gray-600 text-base">
            治理能力的提升是一个持续过程，星贸云帮助企业从工具辅助逐步升级到能力化合规
          </p>
        </div>
      </div>
    </section>
  );
};

export default GovernanceValue;
